import React, { Component } from 'react'
import { Modal, Layout, Form, Input, Icon, Checkbox, Button, Radio, Row, Col } from 'antd'
import { submitCategory, updateCategory } from '../../actions'
import { connect } from 'react-redux'

class Category extends Component {
    handleSubmit = e => {
        e.preventDefault();
        const { selectedActiveCategory } = this.props

        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                if (Object.entries(this.props.selectedActiveCategory).length === 0) {
                    this.props.onSubmitCategory(values).then((res) => {
                        if (!res.error) {
                            this.props.close('exit')
                            Modal.success({
                                // title: "Draft!",
                                content: "Great! You have added new category.",
                                okText: ' Okay',
                                className: '',
                            });
                        }
                    })
                } else {
                    this.props.onUpdateCategory({ values, selectedActiveCategory }).then((res) => {
                        if (!res.error) {
                            this.props.close('exit')
                            Modal.success({
                                // title: "Draft!",
                                content: "Great! You have updated the category.",
                                okText: ' Okay',
                                className: '',
                            });
                        }
                    })
                }
            }
        });
    };

    render() {
        const { selectedActiveCategory } = this.props
        const { getFieldDecorator } = this.props.form;
        return (
            <Layout  >
                <Layout.Content>
                    <Modal
                        title={(Object.entries(this.props.selectedActiveCategory).length === 0 ? 'Add New Category' : 'Edit Category')}
                        visible={this.props.visible}
                        onOk={this.handleOk}
                        footer={null}
                        className="faq-modal-new-category"
                        width={800}
                        onCancel={() => this.props.close('exit')}
                    >
                        <Form onSubmit={this.handleSubmit} className="faq-modal-form">
                            <Row>
                                <Col md={24}>
                                    <Form.Item className='faq-view-options'>
                                        <label>VIEW OPTIONS</label><br />
                                        {getFieldDecorator('type', {
                                            initialValue: selectedActiveCategory.type,
                                            rules: [{ required: true, message: 'Please Select View Options!' }],
                                        })(
                                            <div className='faq-view-options-radio-btn'>
                                                <input type="radio" id="loggedIn" defaultChecked={selectedActiveCategory.type === 1} name="viewOptions" value={1} />
                                                <label htmlFor="loggedIn">Logged In</label><br />
                                                <input type="radio" id="notLoggedIn" defaultChecked={selectedActiveCategory.type === 0} name="viewOptions" value={0} />
                                                <label htmlFor="notLoggedIn">Both</label>
                                            </div>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col md={24}>
                                    <Form.Item>
                                        <label>CATEGORY NAME</label>
                                        {getFieldDecorator('category', {
                                            initialValue: selectedActiveCategory.category && selectedActiveCategory.category.replace(/\w\S*/g, function (string) { return string.charAt(0).toUpperCase() + string.substr(1).toLowerCase() }),
                                            rules: [{ required: true, message: 'Please input your Category Name!' }],
                                        })(
                                            <Input
                                                className='input-line'
                                                placeholder="Type Category Name"
                                                style={{ textTransform: 'capitalize' }}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col md={24}>
                                    <Col span={24} align="right">
                                        <Form.Item>
                                            <Button key="back" onClick={() => this.props.close('exit')} className="faq-modal-cancel-btn" disabled={false}>
                                                <span>Close</span>
                                            </Button>
                                            &nbsp;
                                            <Button type="primary" htmlType="submit" className="faq-modal-submit-btn" disabled={this.props.submitCategoryLoading} loading={this.props.submitCategoryLoading}>
                                                <span>{(Object.entries(this.props.selectedActiveCategory).length === 0 ? 'Add New Category' : 'Edit Category')}</span>
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Col>
                            </Row>
                        </Form>
                    </Modal>
                </Layout.Content>
            </Layout >
        )
    }
}


function mapStateToProps(state) {
    return {
        submitCategoryLoading: state.FAQ.submitCategoryLoading
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onSubmitCategory: (data) => dispatch(submitCategory(data)),
        onUpdateCategory: (data) => dispatch(updateCategory(data)),

    }
}

const NewCategory = Form.create({ name: 'AddEditCategory' })(Category);
export default connect(mapStateToProps, mapDispatchToProps)(NewCategory);